import { useLanguage } from "../contexts/LanguageContext";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FacebookOutlinedIcon from '@mui/icons-material/FacebookOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export default function Footer() {
    const { t } = useLanguage();
    return (
        <footer className="w-full bg-[#244473]/75 border-t-2 border-white">
            <div className="grid grid-cols-1 md:grid-cols-4 p-5 gap-14">
                <div>
                    <img src="images/logo.png" alt="logo" className="w-25 h-20" />
                    <p className="text-white text-xs mt-5">{t('footer.description')}</p>
                </div>
                <div className="align-center justify-self-center">
                    <h3 className="text-white text-lg font-semibold">{t('footer.workTime')}</h3>
                    <div className="flex gap-2 items-end">
                        <AccessTimeOutlinedIcon sx={{ fontSize: 25 }} className="text-white" />
                        <p className="text-white text-xs mt-5">{t('footer.workTimeDescription')}</p>
                    </div>
                    <div className="flex gap-2 items-end mt-5">
                        <LocationOnOutlinedIcon sx={{ fontSize: 25 }} className="text-white" />
                        <a
                            href="https://maps.app.goo.gl/Hqw1ZpLFXQuC3Cjj7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-xs text-white opacity-90 hover:text-blue-200 transition-colors duration-300 md:underline"
                        >
                            {t('footer.address')}
                        </a>
                    </div>
                    <div className="flex gap-2 items-end mt-5">
                        <PhoneOutlinedIcon sx={{ fontSize: 25 }} className="text-white" />
                        <a
                            href="tel:+966549029474"
                            className="text-xs text-white opacity-90 hover:text-blue-200 transition-colors duration-300 md:underline"
                            dir="ltr"
                        >
                            {t('footer.phone')}
                        </a>
                    </div>
                    <div className="flex gap-2 items-end mt-5">
                        <EmailOutlinedIcon sx={{ fontSize: 25 }} className="text-white" />
                        <a
                            href="mailto:moktamel@moktamel.net"
                            className="text-xs text-white opacity-90 hover:text-blue-200 transition-colors duration-300 md:underline"
                        >
                            {t('footer.email')}
                        </a>
                    </div>
                </div>
                <div className="align-center md:justify-self-center">
                    <h3 className="text-white text-lg font-semibold">{t('footer.linksTitle')}</h3>
                    <ul className="text-white text-sm list-disc gap-5 flex flex-col ms-3 mt-5">
                        <li className="hover:scale-105 transition-all duration-300 hover:text-gray-300 hover:font-bold"><a href="/">{t('footer.links.link1')}</a></li>
                        <li className="hover:scale-105 transition-all duration-300 hover:text-gray-300 hover:font-bold"><a href="/services">{t('footer.links.link2')}</a></li>
                        <li className="hover:scale-105 transition-all duration-300 hover:text-gray-300 hover:font-bold"><a href="/contact">{t('footer.links.link3')}</a></li>

                    </ul>
                </div>
                <div className="self-end">
                    <div className="flex flex-col gap-5">
                        <h3 className="text-white text-lg font-semibold">{t('footer.socialTitle')}</h3>
                        <div className="flex gap-5">
                            <a href="/"><FacebookOutlinedIcon sx={{ fontSize: 35 }} className="text-white hover:scale-105 transition-all duration-300" /></a>
                            <a href="https://www.instagram.com/mfbs10"><InstagramIcon sx={{ fontSize: 35 }} className="text-white hover:scale-105 transition-all duration-300" /></a>
                            <a href="https://x.com/mktmlc"><XIcon sx={{ fontSize: 35 }} className="text-white hover:scale-105 transition-all duration-300" /></a>
                            <a href="https://www.linkedin.com/in/moktamel-for-business-solution-2781b9386"><LinkedInIcon sx={{ fontSize: 35 }} className="text-white hover:scale-105 transition-all duration-300" /></a>
                        </div>
                        <div>
                            <hr />
                            <p className="text-white text-xs mt-5">{t('footer.copyright')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}